export function yieldToMainThread() {
  return new Promise(function (resolve) {
    return setTimeout(resolve, 0);
  });
}